import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Container, classNames, Separator } from "@opensea/ui-kit";
import { MintModule } from "@/components/collection/drops/components/MintModule";
import { VoyageScrollIndicator } from "@/components/rewards/Rewards/VoyageScrollIndicator";
import { fullBleedVariants } from "@/styles/utils/page-container";
import { topStickyVariants } from "@/styles/utils/sticky";
import { CollectionOverviewFragment } from "./CollectionOverview.fragment";
import { ModuleContainer } from "./components/ModuleContainer";
import { getComponent, OverviewSection } from "./OverviewSection";
export function CollectionOverview(t0) {
  const $ = _c(12);
  const {
    hasDrop,
    overview: overviewKey
  } = t0;
  let t1;
  if ($[0] !== overviewKey) {
    t1 = readFragment(CollectionOverviewFragment, overviewKey);
    $[0] = overviewKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Separator className={classNames(fullBleedVariants(), topStickyVariants({
      variant: "after-hero-header-tab-menu"
    }))} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== collection || $[4] !== hasDrop) {
    t3 = hasDrop ? <OverviewSection><Container><MintModule collection={collection} /></Container></OverviewSection> : null;
    $[3] = collection;
    $[4] = hasDrop;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== collection?.overview?.modules) {
    t4 = collection?.overview?.modules?.map(_temp);
    $[6] = collection?.overview?.modules;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <VoyageScrollIndicator />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4) {
    t6 = <>{t2}<ModuleContainer className="gap-1">{t3}{t4}{t5}</ModuleContainer></>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(module, index) {
  return <OverviewSection key={index}>{getComponent(module)}</OverviewSection>;
}